import { ApiOrderDetailsInsuranceItemResponse, Insurance, mapInsuranceItem } from './insurance.model';
import { Order } from './order.model';

// API Models

export interface ApiOrderDetailsItemResponse {
  itemId: number;
  itemDescription: string;
  categoryName?: string;
  quantity: number;
  totalQuantity: number;
}

export interface ApiOrderDetailsResponse {
  orderItemDetails?: ApiOrderDetailsItemResponse[];
  primaryInsurance?: ApiOrderDetailsInsuranceItemResponse;
  secondaryInsurance?: ApiOrderDetailsInsuranceItemResponse;
}

// Front End Models

export interface OrderDetailsItem {
  id: number;
  description: string;
  category?: string;
  quantity: number;
}

export interface OrderDetails extends Order {
  items: OrderDetailsItem[];
  primaryInsurance?: Insurance;
  secondaryInsurance?: Insurance;
}

// Mappers

export const mapOrderDetails = (o: ApiOrderDetailsResponse, matchingOrder: Order): OrderDetails => {
  // TODO fetch all orders first and merge objects here.
  return {
    ...matchingOrder,
    items: (o.orderItemDetails || []).map((oi) => ({
      id: oi.itemId,
      description: oi.itemDescription,
      category: oi.categoryName,
      quantity: oi.quantity,
    })),
    primaryInsurance: o.primaryInsurance ? mapInsuranceItem(o.primaryInsurance) : undefined,
    secondaryInsurance: o.secondaryInsurance ? mapInsuranceItem(o.secondaryInsurance) : undefined,
  };
};
